var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIconEmphasized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0692 5.39853C18.7939 4.6738 19.9666 4.6738 20.6914 5.39853C21.4161 6.12327 21.4161 7.29598 20.6914 8.02071L10.1114 18.6007C9.38662 19.3255 8.21391 19.3255 7.48918 18.6007L3.30918 14.4207C2.58444 13.696 2.58444 12.5233 3.30918 11.7985C4.03391 11.0738 5.20662 11.0738 5.93136 11.7985L8.79557 14.6627L18.0692 5.39853Z",
    fill: "#087A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconEmphasized);
export default __webpack_public_path__ + "static/media/check-icon-emphasized.8d4f7a7351a767b357193a34841b2c00.svg";
export { ForwardRef as ReactComponent };